export default "__VITE_ASSET__rQaIBqgB4QtNGFvuCgjmaA__"